const template = require('./search.html.slim')
declare var angular

export class Search {
  static $inject = ['$rootScope']

  constructor(private $rootScope) { }
}

angular.module('wbComponents').directive('wbSearch', function() {
  return {
    restrict: 'E',
    templateUrl: template,
    controller: Search,
    controllerAs: 'ctrl',
    bindToController: true,
  }
})
